(function () {
	const LINK_ID = 'boa-rtl-forms-fix';
	const script = document.getElementById('boa-rtl-forms-fix-js');
	const HREF = script && script.dataset ? script.dataset.href : '';
	if (!HREF) return;

	function patch(host) {
		const root = host.shadowRoot;
		if (!root) return false;
		if (root.getElementById(LINK_ID)) return true;
		const link = document.createElement('link');
		link.id = LINK_ID;
		link.rel = 'stylesheet';
		link.href = HREF;
		root.appendChild(link);
		return true;
	}

	function patchWithRetry(host, tries) {
		if (patch(host) || tries <= 0) return;
		setTimeout(function () {
			patchWithRetry(host, tries - 1);
		}, 200);
	}

	function scan() {
		var hosts = document.querySelectorAll('shopify-forms-embed');
		for (var i = 0; i < hosts.length; i++) {
			patchWithRetry(hosts[i], 25);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scan);
	} else {
		scan();
	}

	new MutationObserver(scan).observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
})();
